module.exports = __webpack_public_path__ + "img/icon-home-credit-active.5851104b.svg";